const TinyMasonry = require('./tiny-masonry');

const megaLinks = document.querySelectorAll('.js-mega-link');

megaLinks.forEach((megaLink) => {
    megaLink.addEventListener('mouseenter', () => {
        window.dispatchEvent(new Event('resize'));
    });

    const masonryEls = megaLink.querySelectorAll('.js-masonry');
    masonryEls.forEach((masonryEl) => {
        const columns = masonryEl.getAttribute('data-columns');
        // eslint-disable-next-line no-new
        new TinyMasonry(masonryEl, columns);
    });
});
